<template>
	<div ref="select"
		class="dy-select-main" 
		:class="{selectDisable:disable}"
		@mousedown="mousedown" 
		@click.stop="click">
		<div class="dy-select-text">{{elem.innerText || placeholder}}</div>
		<div v-show="showBox" 
			ref="options" 
			class="dy-select-box" 
			tabindex="-1"
			@blur="showBox=false"
			@click.stop="showBox=false">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name:"dy-select",
		props:{
			disable:{
				type:Boolean,
				default:false,
			},
			modelValue:{
				type:[String,Number,Object],
				default:''
			},
			placeholder:{
				type:String,
				default:''
			},
		},
		watch:{
			modelValue:{
				handler(val,old){
					setTimeout(()=>{
						if(!this.$refs || !this.$refs.options || !this.$refs.options.children) return;
						for(let elem of this.$refs.options.children) {
							if(elem.getAttribute('value') == val){ 
								elem.classList.add('selected');
								this.elem.classList && this.elem.classList.remove('selected');
								this.elem = elem;
								break;
							}
						}
					},10)
				},
				immediate:true
			}
		},
		data() {
			return {
				showBox:false,
				elem:{value:'', innerText:''},
			};
		},
		
		methods:{
			popup(){
				this.showBox = !this.showBox;
				const rect = this.$refs.select.getBoundingClientRect();
				const rect2 = document.querySelector('.dy-select-main').getBoundingClientRect();
				console.log(rect, rect2);
				this.$nextTick(()=>{
					const box = this.$refs.options;
					// box.style.position = 'fixed';
					// box.style.top = rect.bottom + 'px';
					// box.style.left = rect.left + 'px';
					box.style.minWidth = rect.width + 'px';
					box.style.width = 'auto';
					box.focus();
				});
			},
			mousedown(e){
				
			},
			click(e){
				let elem = e.target;
				const rect = this.$refs.select.getBoundingClientRect();
				const box = this.$refs.options;
				document.body.appendChild(box);
				this.showBox = true;
				
				box.onclick = (e)=>{
					this.$refs.select.appendChild(box);
					this.$nextTick(()=>{
						this.showBox = false;
						let elem = e.target;
						if(elem.nodeName == 'A')
						{
							let val = elem.getAttribute('value');
							if(val && !isNaN(val)) val = Number(val);
							this.showBox = false;
							this.$emit('update:modelValue', val);
							this.$emit('change', val);
						}
					})
				}
				
				this.$nextTick(()=>{
					box.style.top = rect.bottom + 'px';
					box.style.left = rect.left + 'px';
					box.style.minWidth = rect.width + 'px';
					box.style.width = 'auto';
					box.focus();
				});
			},
		}
	}
</script>

<style scoped>
.dy-select-main{
	width:100%;
	background-color: #161619;
	position:relative;
	min-width:80px;
	/* height:30px; */
	line-height:30px;
	font-size:14px;
	font-weight: 500;
	padding:0 10px;
	box-sizing: border-box;
	border-radius:15px;
	z-index: 10;
}
.dy-select-main:hover{
	cursor: pointer;
	/* background-color:#383838; */
}
.selectDisable{
	/* background-color:#F8F8F8 !important; */
	pointer-events:none;
}
.dy-select-text{
	display:block;
	width:100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	/* padding-left:5px; */
	box-sizing: border-box;
}
.dy-select-text:before{
	font-family: "iconfont" !important;
	font-size: 16px;
	font-style: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	content: "\eb0f";
	opacity: 0.6;
	float:right;
}
.dy-select-box{
	display:block;
	position:fixed;
	max-height:360px;
	z-index:9999;
	background: #fff;
	border-radius:5px;
	border: 1px solid #EFEFEF;
	padding:10px;
	padding-right: 0;
	overflow-y: auto;
	left: 0;
	top:0;
	margin-top:4px;
	box-sizing: border-box;
	border-radius:15px;
	z-index:9999;
}
.dy-select-box >>> a{
	display:block;
	color:#1A1A1A;
	font-size:14px;
	font-weight: 500;
	text-align: left;
	line-height: 18px;
	width:calc(100% - 10px);
	height:28px;
	padding:6px 10px;
	border-radius:15px;
	white-space: nowrap;
	box-sizing: border-box;
	padding-right:30px;
}

.dy-select-box >>> a:hover{
	background-color: #e0e0e0;
}

.dy-select-box >>> a.selected:before{
	color:rgb(99, 120, 231);
	font-family: "iconfont" !important;
	font-size: 16px;
	font-style: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	content: "\ea84";
	position:absolute;
	right:5px;
	/* float:right;
	margin-right:-26px; */
}
</style>